import { useEffect } from 'react';
import { isEmpty } from 'lodash';

export function buildFacebookConversionData(booking) {
  // Prepare dataset for FB tracking
  const trackingData = {
    value: booking.gross_in_cents / 100,
    currency: booking.currency_iso_code,
    contents: [],
  };

  function addContent(reservation) {
    const existing = trackingData.contents.find(
      (item) => item.id === reservation.resource_id
    );

    if (!isEmpty(existing)) {
      existing.quantity += reservation.passenger_ids.length;
    } else {
      trackingData.contents.push({
        id: reservation.resource_id,
        name: reservation.selection_name,
        quantity: reservation.passenger_ids.length,
      });
    }
  }

  booking.reservations_attributes.forEach((reservation) => {
    addContent(reservation);

    if (!isEmpty(reservation.sub_reservations_attributes)) {
      reservation.sub_reservations_attributes.forEach((subReservation) =>
        addContent(subReservation)
      );
    }
  });

  return trackingData;
}

// This hook assume that the the Vero tracking has been initialised elsewhere
export const useVeroTracking = (eventName) => {
  useEffect(() => {
    // eslint-disable-next-line
    const _veroq = window._veroq || [];

    _veroq.push(['track', eventName, {}]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
